import lyImg from "@images/gamesPage/guests/ly.jpeg"
import ztImg from "@images/gamesPage/guests/zt.jpeg"
import hongImg from "@images/gamesPage/guests/hong.jpeg"
import qzImg from "@images/gamesPage/guests/qz.png"
import gmImg from "@images/gamesPage/guests/gm.jpeg"
import ygzlImg from "@images/gamesPage/guests/ygzl.jpeg"
import jybyImg from "@images/gamesPage/guests/jyby.jpeg"
import nwyImg from "@images/gamesPage/guests/nwy.jpeg"
import ldImg from "@images/gamesPage/guests/leidian.jpeg"
import mzsImg from "@images/gamesPage/guests/mzs.webp"
import mufeiImg from "@images/gamesPage/guests/mufei.png"

export const guests = [
  {
    name: "老杨",
    img: lyImg,
    desc: "《帕斯卡契约》制作人",
    id: "342672",
  },
  {
    name: "张弢",
    img: ztImg,
    desc: "《暗影火炬城》制作人",
    id: "591877",
  },
  {
    name: "邓卜冉",
    img: "https://image.gcores.com/a667ccdf-f650-4c12-89a9-4ad26f420017.jpg?x-oss-process=image/resize,limit_1,m_fill,w_300,h_300/quality,q_90/bright,-20",
    desc: "《完美的一天》制作人",
    id: "126249",
  },
  {
    name: "Hong",
    img: hongImg,
    desc: "《风来之国》主美",
    id: "20496",
  },
  {
    name: "穆飞",
    img: mufeiImg,
    desc: "《硬核机甲》制作人",
    id: "13515",
  },
  {
    name: "茄子",
    img: qzImg,
    desc: "《太吾绘卷》制作人",
    id: "601422",
  },
  {
    name: "高鸣",
    img: gmImg,
    desc: "《蜡烛人》制作人",
    id: "81076",
  },
  {
    name: "月光蟑螂MR",
    img: ygzlImg,
    desc: "《三伏》《烟火》制作人",
    id: "96246",
  },
  {
    name: "Awen",
    img: jybyImg,
    desc: "《纪元 变异》制作人",
    id: "45723",
  },
  {
    name: "女王盐",
    img: nwyImg,
    desc: "知名游戏主播",
    id: "42221",
  },
  {
    name: "雷电",
    img: ldImg,
    desc: "知名游戏主播",
    id: "54486",
  },
  {
    name: "谜之声",
    img: mzsImg,
    desc: "知名游戏主播",
    id: "611966",
  },
]
